import { render, staticRenderFns } from "./app_detail.vue?vue&type=template&id=6592ddc2&scoped=true"
import script from "./app_detail.vue?vue&type=script&lang=js"
export * from "./app_detail.vue?vue&type=script&lang=js"
import style0 from "./app_detail.vue?vue&type=style&index=0&id=6592ddc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592ddc2",
  null
  
)

export default component.exports